const t = {
  name: "CustomerInsights",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 18H19V2H21V18Z" fill="currentColor"/>
<path d="M11 18H13V6H11V18Z" fill="currentColor"/>
<path d="M9 18H7V12H9V18Z" fill="currentColor"/>
<path d="M5 18V15H3V18H5Z" fill="currentColor"/>
<path d="M22 20H2V22H22V20Z" fill="currentColor"/>
<path d="M17 9V18H15V9H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CustomerInsights
};
